import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import classes from "./LogoCarousel.module.css";

const logos = [
    "/images/brand-carousel/b-1.png",
    "/images/brand-carousel/b-2.png",
    "/images/brand-carousel/b-3.png",
    "/images/brand-carousel/b-4.png",
    "/images/brand-carousel/b-5.png",
    "/images/brand-carousel/b-6.png",
    "/images/brand-carousel/b-1.png",
    "/images/brand-carousel/b-2.png",
    "/images/brand-carousel/b-3.png",
    "/images/brand-carousel/b-4.png",
    "/images/brand-carousel/b-5.png",
    "/images/brand-carousel/b-6.png",
];

const LogoCarousel = () => {
    return (
        <section className={classes.logoSection}>

            {/* <div className={classes.topGlow} /> */}

            <div className={classes.section_carousel_marquee}>
                <div className={classes.section_carousel_sub_container}>
                    {logos.map((item, index) => {
                        return (
                            <div key={index} className={classes.section_carousel_item}>
                                <img src={item} alt="" className={classes.section_carousel_item_image} />
                            </div>
                        )
                    })}

                    {logos.map((item, index) => {
                        return (
                            <div key={index} className={classes.section_carousel_item}>
                                <img src={item} alt="" className={classes.section_carousel_item_image} />
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
};

export default LogoCarousel;